export const site = {
  name: "Nkadimeng Danny Legal and Compliance Support",
  shortName: "Nkadimeng Danny Legal",
  tagline:
    "Professional legal and compliance support you can trust — across South Africa.",
  phone: "071 276 6198",
  phoneIntl: "+27712766198",
  email: "nkadimengdanny7@gmail.com",
  whatsapp: "27712766198",
  social: {
    facebook: "https://www.facebook.com/dboy.dannyboy2/",
    linkedin: "https://www.linkedin.com/in/danny-nkadimeng-4011253a2/",
  },
  // ---------------------------------------------------------------
  // Registered enterprise details — CIPC (Companies & Intellectual
  // Property Commission), Republic of South Africa. Displayed on the
  // website footer, invoices, receipts, contracts, quotations and
  // JSON-LD structured data so counterparties can verify the entity.
  // ---------------------------------------------------------------
  registration: {
    // CIPC registration number (formatted YYYY/NNNNNN/07)
    number: "2026/518678/07",
    // Enterprise / Customer number (short form used on some COR forms)
    enterpriseNumber: "K2026518678",
    entityType: "Private Company (Pty) Ltd",
    incorporatedOn: "01 July 2026",
    financialYearEnd: "March",
    // SARS income-tax reference number (kept private; not displayed on the
    // public website, invoices, contracts or JSON-LD).
    taxNumber: null as string | null,
    // Not registered for VAT (below the R1m threshold). Update when applicable.
    vatNumber: null as string | null,
    director: "Danny Nkadimeng",
  },
  address: {
    line1: "623 Mpheleng Village",
    line2: "Dennilton, Groblersdal",
    province: "Limpopo",
    postalCode: "1030",
    country: "South Africa",
    single:
      "623 Mpheleng Village, Dennilton, Groblersdal, Limpopo, 1030, South Africa",
  },
  // Live banking details — Capitec Business (Entrepreneur)
  banking: {
    accountName: "Nkadimeng Danny Legal and Compliance Support",
    bank: "Capitec Bank",
    accountType: "Entrepreneur (Business)",
    accountNumber: "2555604991",
    branchCode: "470010",
    address: "Stand No 623 Mpheleng, Ward 05, Dennilton, 1030",
    reference: "Use your invoice / order reference",
  },
  // Default consultation fee charged when issuing the invoice
  consultationFee: 500,
  // Google Form fallback for document submissions. The Apps Script attached
  // to this form forwards every upload to /api/public/google-forms-upload,
  // which stores the file in the secure client-documents bucket.
  documentUploadFormUrl:
    "https://docs.google.com/forms/d/e/1FAIpQLScC-rX_Lpxw5JWsgv4E2qVEmYx5PthvzTB2-uJFpwMHEdhWlA/viewform",
};

// Convenience — a single line suitable for invoice footers and email
// signatures ("Reg 2026/518678/07 · Tax 9480340232").
export function companyRegLine(): string {
  const parts = [`Reg ${site.registration.number}`];
  if (site.registration.taxNumber)
    parts.push(`Tax ${site.registration.taxNumber}`);
  if (site.registration.vatNumber)
    parts.push(`VAT ${site.registration.vatNumber}`);
  return parts.join(" · ");
}
